module.exports = __webpack_public_path__ + "img/ye.9802a254.svg";